import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useWebHaptics } from "web-haptics/react";
import { useSounds } from "context";
import useLocalStorage from "hook/useLocalStorage";

type Props = {
    children: React.ReactElement;
    disabled?: boolean;
};

const supportsHover = typeof window !== "undefined" && typeof window.matchMedia === "function"
    && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

export default function ButtonHapticWrapper({ children, disabled }: Props) {
    const { play } = useSounds();
    const { trigger } = useWebHaptics();
    const [hapticEnabled] = useLocalStorage<boolean>("LASTDOTCARDS.HAPTIC", true);

    const child = React.Children.only(children);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const childProps = child.props as Record<string, any>;

    return React.cloneElement(child, {
        ref: (node: HTMLElement) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const r = (child as any).ref as ((node: HTMLElement | null) => void) | React.RefObject<HTMLElement> | null;

            if(typeof r === "function") {
                r(node);
            } else if(r && typeof r === "object") {
                (r as React.MutableRefObject<HTMLElement | null>).current = node;
            }
        },
        onMouseEnter: (e: React.MouseEvent) => {
            childProps.onMouseEnter?.(e);

            if(!disabled && supportsHover) {
                play("hover");
            }
        },
        onClick: (e: React.MouseEvent) => {
            childProps.onClick?.(e);

            if(!disabled) {
                play("click");

                if(hapticEnabled) {
                    trigger("light");
                }
            }
        },
    });
}
